import * as yup from "yup";
import { VALID_DATE, TIME_NOT_IN_FUTURE } from "@common/constants/validation";

// Define the validation schema using yup
export const enforcementSchema = yup.object().shape({
  date: VALID_DATE,
  time: TIME_NOT_IN_FUTURE,
  officerTypeId: yup.number().required("Officer type is required"),
  visitDetails: yup.string().required("Nature of visit is required"),
  incidentNumber: yup.string().when("officerTypeId", {
    is: (x) => x === 1,
    then: (schema) => schema.required("Incident number is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  officer: yup.object().required("Officer is required"),
  comments: yup.string().notRequired(),
});
